export const options = [
  {
    id: 1,
    code: "pd",
    name: "personal_data",
    description_lang_key: "personal_data",
    path: "/editor/is/pd/",
    permissions: "employeeAccounting.personal.info.get",
  },
  {
    id: 2,
    code: "is",
    name: "information_systems",
    description_lang_key: "info_system",
    path: "/editor/is/dis/",
    permissions: "employeeAccounting.information.system.get",
  },
];
